import {
  faBoxes,
  faBuilding,
  faCogs,
  faDatabase,
  faFolder,
  faProjector,
  faServer,
  faUser,
  IconDefinition,
} from '@fortawesome/pro-light-svg-icons';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SidebarItemsContainer from '../sidebar/SidebarItemsContainer';
import SidebarItem from '../sidebar/SidebarItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface NavItem {
  key: string;
  label: string;
  link: string;
  icon: IconDefinition;
  pathPrefix: string;
}

const items: NavItem[] = [
  {
    key: 'providerConfigs',
    link: '/admin/providerConfigs',
    pathPrefix: '/admin/providerConfigs',
    label: 'Einstellungen',
    icon: faProjector,
  },
  {
    key: 'instanceConfig',
    link: '/admin/instanceConfig',
    pathPrefix: '/admin/instanceConfig',
    label: 'Systemeinstellungen',
    icon: faServer,
  },
  {
    key: 'companies',
    link: '/admin/companies',
    pathPrefix: '/admin/companies',
    label: 'Firmen',
    icon: faBuilding,
  },
  {
    key: 'modules',
    link: '/admin/modules',
    pathPrefix: '/admin/modules',
    label: 'Module',
    icon: faBoxes,
  },
  {
    key: 'categories',
    link: '/admin/categories',
    pathPrefix: '/admin/categories',
    label: 'Kategorien',
    icon: faFolder,
  },
  {
    key: 'taskDefinitions',
    link: '/admin/taskDefinitions',
    pathPrefix: '/admin/taskDefinition',
    label: 'Aufgaben',
    icon: faCogs,
  },
];

const AdminSidebar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <SidebarItemsContainer>
      {items.map((item) => (
        <SidebarItem
          key={item.key}
          label={item.label}
          icon={item.icon}
          onClick={() => navigate(item.link)}
          isActive={pathname.startsWith(item.pathPrefix)}
        />
      ))}
    </SidebarItemsContainer>
  );
};

export default AdminSidebar;
